import { useMutation } from '@tanstack/react-query';

import { ordersRecognitionApi } from '@widgets/OrdersRecognition/api';
import { useSaveBudgetItemComment } from '@widgets/OrdersRecognition/api/hooks';
import { useUpdateItemDate } from '@widgets/OrdersRecognition/api/hooks/useUpdateItemDate';

export const useCreateExcessItem = () => {
    const saveBudgetItemCommentMutation = useSaveBudgetItemComment('excess');
    const useUpdateItemDateMutation = useUpdateItemDate('excess');

    return useMutation({
        mutationFn: ordersRecognitionApi.createExcessItem,
        onSuccess: async (res, variables) => {
            console.log('success update budget item', res);
            console.log('variables', variables);
            await saveBudgetItemCommentMutation.mutateAsync({
                itemGuid: res?.data?.data?.id,
                displayString: variables?.data?.comment,
            });

            if (variables?.data?.documentDate) {
                await useUpdateItemDateMutation.mutateAsync({
                    itemGuid: res?.data?.data?.guid,
                    documentDate: variables?.data?.documentDate,
                });
            }
        },
    });
};
